export default "__VITE_ASSET__BNeOXSle__ 1200w";